import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const notifications = [{
  name: 'María',
  city: 'Bogotá'
}, {
  name: 'Luciana',
  city: 'Buenos Aires'
}, {
  name: 'Sofía',
  city: 'Lima'
}, {
  name: 'Carolina',
  city: 'Santiago'
}, {
  name: 'Ana',
  city: 'Medellín'
}, {
  name: 'Valentina',
  city: 'Montevideo'
}, {
  name: 'Camila',
  city: 'Córdoba'
}, {
  name: 'Martina',
  city: 'Rosario'
}];
export function SocialProofPopup() {
  const [currentNotification, setCurrentNotification] = useState<(typeof notifications)[0] | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showRandomNotification();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showRandomNotification = () => {
    const random = notifications[Math.floor(Math.random() * notifications.length)];
    setCurrentNotification(random);
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next one (between 8 and 15 seconds)
      const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(showRandomNotification, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-164">
      {isVisible && currentNotification && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-[300px] bg-white rounded-xl shadow-2xl border border-brand-bg-beige p-4 flex items-start gap-3" data-id="element-165">
          <div className="bg-brand-green/10 p-2 rounded-full flex-shrink-0 mt-0.5" data-id="element-166">
            <ShoppingBag className="w-5 h-5 text-brand-green" data-id="element-167" />
          </div>
          <div data-id="element-168">
            <p className="text-sm font-medium text-brand-text-dark leading-tight" data-id="element-169">
              <span className="font-bold" data-id="element-170">{currentNotification.name}</span> de{' '}
              {currentNotification.city} acaba de comprar este programa
            </p>
            <p className="text-xs text-brand-text-medium mt-1" data-id="element-171">
              Hace unos minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}